import script from "./DrawsTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./DrawsTab.vue?vue&type=script&setup=true&lang=ts"

import "@/assets/css/card.css?vue&type=style&index=0&id=c050429c&scoped=true&lang=css&external"
import "@/assets/css/loans/draw-disbursement-details.css?vue&type=style&index=1&id=c050429c&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c050429c"]])

export default __exports__